import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL } from "../lib/contact";

const links = [
  { id: "quienes-somos", label: "Quiénes somos" },
  { id: "que-hacemos", label: "Qué hacemos" },
  { id: "beneficios", label: "Beneficios" },
  { id: "portafolio", label: "Portafolio" },
  { id: "redes", label: "Nuestras redes" },
  { id: "contacto", label: "Contacto" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-md bg-[#eeede9]/85 border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-2.5 h-2.5 bg-[#ca0013] rounded-full" />
          <span className="text-xl md:text-2xl tracking-tight leading-none flex items-baseline">
            <span className="font-editorial text-[#ca0013]">Vertex</span>
            <span className="font-display text-[#ca0013] pl-1.5 lowercase" style={{ fontWeight: 800 }}>
              house
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => handleNav(l.id)}
              className="font-body text-sm font-semibold text-[#111] hover:text-[#ca0013] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-cta-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex items-center gap-2 bg-[#ca0013] hover:bg-[#a80010] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors font-body"
        >
          Analizamos tu negocio sin costo
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 -mr-2"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#eeede9] border-t border-black/10 px-6 py-6 space-y-4"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => handleNav(l.id)}
              className="block w-full text-left font-display text-2xl tracking-tight text-[#111] hover:text-[#ca0013]"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-mobile-cta-whatsapp"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#ca0013] text-white font-bold px-6 py-3 rounded-full mt-2"
          >
            Analizamos tu negocio sin costo
          </a>
        </div>
      )}
    </header>
  );
};
